import {HttpCodeError} from "@/common/server/exception/HttpCodeError";
import * as signalR from "@microsoft/signalr";
import {__BUILD_COMMIT_HASH__} from "../../../version";

let sessionIdBuf = new Uint8Array(16);
crypto.getRandomValues(sessionIdBuf);
let sessionId;
try {
    sessionId = sessionIdBuf.toBase64()
} catch (e) {
    sessionId = btoa(String.fromCharCode(...sessionIdBuf));
}
window.__sessionId = sessionId;

export function getServerBaseUrl() {
    const isDebug = location.host.endsWith(':8080');
    return isDebug ? 'http://localhost:5000/frontendApi/' : (location.protocol + '//' + location.host + '/frontendApi/');
}

async function ApiFunction(controller, action, method, arg) {
    let baseUrl = getServerBaseUrl();
    let fetchConfig = {
        method,
        headers: {
            'x-session-id': sessionId,
            'x-frontend-version': __BUILD_COMMIT_HASH__
        }
    };
    if (method != 'get') {
        if (arg instanceof FormData) {
            fetchConfig.body = arg;
        } else {
            fetchConfig.body = JSON.stringify(arg);
            fetchConfig.headers['Content-Type'] = 'application/json';
        }
    }
    if (localStorage.token) {
        fetchConfig.headers.Authorization = 'Bearer ' + localStorage.token;
    }
    const response = await fetch(baseUrl + controller + '/' + action, fetchConfig)
    const contentDisposition = response.headers.get('content-disposition');
    const backendCommitHash = response.headers.get('x-build-commit-hash');
    console.log('x-build-commit-hash', backendCommitHash);
    if (backendCommitHash) {
        window.__BACKEND_COMMIT_HASH__ = backendCommitHash;
    }
    if (contentDisposition) {
        const filename = response.headers.get('content-disposition')
            .split(';')
            .find(n => n.includes('filename='))
            .replace('filename=', '')
            .replace(/"/g, '')
            .trim();
        const blobURL = URL.createObjectURL(await response.blob());
        const a = document.createElement('a');
        a.download = filename;
        a.href = blobURL;
        a.click();
        URL.revokeObjectURL(blobURL);
    } else {
        let text = await response.text();
        if (response.status === 200) {
            return text == "" ? null : JSON.parse(text);
        } else if (response.status === 500) {
            let exception;
            try {
                exception = JSON.parse(text);
            } catch (_) {
                exception = new Error('Http 500: ' + text);
            }
            throw exception
        } else {
            let decoded;
            try {
                decoded = JSON.parse(text);
            } catch (ex) {
                throw new HttpCodeError(response.status, response.statusText);
            }
            throw decoded.error;
        }
    }
}


const ControllerHandler = {
    get(ajaxFunctionBinded, name) {
        const method = ajaxFunctionBinded.bind(window, name, 'post');
        method.post = ajaxFunctionBinded.bind(window, name, 'post');
        method.get = ajaxFunctionBinded.bind(window, name, 'get');
        method.put = ajaxFunctionBinded.bind(window, name, 'put');
        method.delete = ajaxFunctionBinded.bind(window, name, 'delete');
        return method;
    }
};

const ApiHandler = {
    get(obj, name) {
        return new Proxy(ApiFunction.bind(window, name), ControllerHandler);
    }
};
const signalRConnection = new signalR.HubConnectionBuilder().withUrl(getServerBaseUrl() + "signalr").build();
export const SignalR = {
    listeners: {},
    onChangeByType(objectType, callback) {
        console.log('onChangeByType', objectType);
        if (!this.listeners[objectType]) {
            this.listeners[objectType] = [];
        }
        const listener = {objectType, callback}
        listener.remove = () => {
            const index = this.listeners[objectType].indexOf(listener);
            if (index > -1) {
                this.listeners[objectType].splice(index, 1);
            }
        }
        this.listeners[objectType].push(listener);
        return listener;
    }

}
signalRConnection.on("UpdatedData", e => {
    console.log('UpdatedData', e)
    for (const listener of SignalR.listeners[e.objectType] || []) {
        try {
            listener.callback(e);
        } catch (ex) {
            console.error('Error in SignalR listener callback', ex);
        }
    }
})
signalRConnection.start();

export const Server = new Proxy(ApiFunction, ApiHandler);
window.dbgServer = Server;

function getStatisticsInfo() {
    let videoCardInfo = null;
    try {
        const gl = document.createElement('canvas').getContext('webgl');
        if (!gl) {
            return {
                error: "no webgl",
            };
        }
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        videoCardInfo = debugInfo ? {
            vendor: gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL),
            renderer: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL),
        } : {
            error: "no WEBGL_debug_renderer_info",
        };
    } catch (_) {
    }

    return {
        frontendTime: (new Date()).toISOString(),
        videoCardInfo,
        screen: {
            height: window.screen.height,
            width: window.screen.width,
            colorDepth: window.screen.colorDepth,
            orientation: window.screen.orientation.angle
        },
        window: {
            width: window.width,
            height: window.height,
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight
        },
        devicePixelRatio: window.devicePixelRatio,
        darkMode: window.matchMedia('prefers-color-scheme: dark')?.matches,

    }

}

Server.TechnicalLog.SaveSessionStart(getStatisticsInfo())
